import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-238" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance font-display text-4xl font-bold uppercase leading-[1.02] tracking-tight text-foreground sm:text-5xl" data-id="element-239" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-240" data-mp="mzzilvtwspx5">
        <span className="h-1 w-10 rounded-full bg-primary" data-id="element-241" data-mp="i6dfau9mxye0" />
        <span className="h-1 w-3 rounded-full bg-accent" data-id="element-242" data-mp="d8bw89c7lz2j" />
      </span>
    </div>;
}